import api from './api'

// Category types
export interface Category {
  id: string
  name: string
  slug: string
  description?: string | null
  parentId?: string | null
  sortOrder: number
  isActive: boolean
  productCount?: number
  children?: Category[]
  createdAt: string
  updatedAt?: string
}

export interface CreateCategoryDto {
  name: string
  description?: string
  parentId?: string
  sortOrder?: number
  isActive?: boolean
}

export interface UpdateCategoryDto {
  name?: string
  description?: string
  parentId?: string | null
  sortOrder?: number
  isActive?: boolean
}

export const categoriesApi = {
  // Get all categories (tree structure)
  async getAll(): Promise<Category[]> {
    const response = await api.get('/catalog/categories')
    return response.data
  },

  // Get a specific category
  async getById(id: string): Promise<Category> {
    const response = await api.get(`/catalog/categories/${id}`)
    return response.data
  },

  // Create a new category
  async create(data: CreateCategoryDto): Promise<Category> {
    const response = await api.post('/catalog/categories', data)
    return response.data
  },

  // Update a category
  async update(id: string, data: UpdateCategoryDto): Promise<Category> {
    const response = await api.put(`/catalog/categories/${id}`, data)
    return response.data
  },

  // Delete a category
  async delete(id: string): Promise<void> {
    await api.delete(`/catalog/categories/${id}`)
  },
}
